import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Header, Button } from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'
import { DELETE_JOB_MUTATION } from '../../../../../graphql/job'
import { MERGE_USER } from '../../../../../graphql/admin'

const ConfirmMerge = ({ mergeData, updateMergeData, setPage, onClose }) => {
    const { sourceUser, targetUser, deleteSourceUser, jobsToRemove } = mergeData
    const [loading, setLoading] = useState(false)
    const [deleteJob] = useMutation(DELETE_JOB_MUTATION)
    const [mergeUser] = useMutation(MERGE_USER)
    const restart = () => {
        updateMergeData({ deleteSourceUser: false, jobsToRemove: [] })
        setPage('PREVIEW')
    }
    const merge = async () => {
        setLoading(true)
        // Delete the conflict jobs
        await Promise.all(
            jobsToRemove.map((job) =>
                deleteJob({
                    variables: { id: job.id },
                })
            )
        )
        // 2. Merge user
        await mergeUser({
            variables: {
                sourceUserEmail: sourceUser.email,
                targetUserEmail: targetUser.email,
                deleteSourceUser,
            },
            onCompleted: () => {
                alert('The accounts are merged successfully!')
                onClose()
            },
        })
        setLoading(false)
    }
    return (
        <div>
            <Header as="h4">
                {`The expert profile of the account "${sourceUser.email}" will be merged into the expert profile of the account "${targetUser.email}"`}
            </Header>
            <Header as="h4">
                {'Please click "Merge" to confirm the merge'}
            </Header>
            {deleteSourceUser && (
                <Header as="h4" color="red">
                    {`The account "${sourceUser.email}" will be removed after this merge`}
                </Header>
            )}
            <Modal.Footer>
                <Button
                    basic
                    content="Restart"
                    loading={loading}
                    disabled={loading}
                    onClick={restart}
                />
                <Button
                    negative
                    content="Merge"
                    loading={loading}
                    disabled={loading}
                    onClick={merge}
                />
            </Modal.Footer>
        </div>
    )
}

export default ConfirmMerge
